var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.357 65.7052H51.6235V72.572H65.357C69.1337 72.572 72.2237 69.4819 72.2237 65.7052V51.9718H65.357M65.357 10.7715H51.6235V17.6382H65.357V31.3716H72.2237V17.6382C72.2237 13.8615 69.1337 10.7715 65.357 10.7715ZM17.2899 17.6382H31.0234V10.7715H17.2899C13.5132 10.7715 10.4232 13.8615 10.4232 17.6382V31.3716H17.2899M17.2899 51.9718H10.4232V65.7052C10.4232 69.4819 13.5132 72.572 17.2899 72.572H31.0234V65.7052H17.2899V51.9718ZM37.8901 38.2384H44.7568V45.1051H37.8901V38.2384ZM37.8901 24.5049H44.7568V31.3716H37.8901V24.5049ZM37.8901 51.9718H44.7568V58.8385H37.8901V51.9718Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFields);
export default __webpack_public_path__ + "static/media/fields.413b115dbc027613c18d9e44d8ad3b3f.svg";
export { ForwardRef as ReactComponent };